import React, { useEffect, useState } from 'react';
import { raiseClaimService } from '../../services';
import { Formik, Form, Field, FieldArray } from 'formik';
import { decimalNum, noEscChar, policyRegexHyphenSlashScore, required } from '../../helpers/commonYupValidations';
import * as Yup from 'yup';
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { jwtDecode } from "jwt-decode";
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from 'reactstrap';
import moment from 'moment';
import { aesUtil } from '../../utils/aesUtil';

const MultipleAmountAddCommonModal = ({ isModalOpen, handleClose, claimDetails, fetchClaimTemplateDetails, raiseClaimId, checkSettled }) => {
    const claimIntimationDate = claimDetails?.claimIntimationDate;
    const parsedclaimIntimationDate = claimIntimationDate ? moment(claimIntimationDate, "DD-MM-YYYY").toDate() : null;

    const getAssesmentLabel = () => {
        const estimatedLoss = claimDetails?.estimatedLoss;
        if (estimatedLoss && estimatedLoss > 25000) {
            return 'Surveyor Assessment Amount'
        } else {
            return 'Assessment Amount'
        }
    }

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [claimSettlementList, setClaimSettlementList] = useState(null)
    let data = localStorage.getItem('token');
    const decryptToken = typeof data === 'string' ? aesUtil.decrypt(data) : '';
    const decoded = typeof decryptToken === 'string' ? jwtDecode(decryptToken) : null;
    const userRole = decoded?.Role;

    const validationSchema = Yup.object().shape({
        surveyorAssesmentAmount: (claimDetails?.surveyorAppointmentStatus !== 'Self Surveyor' && claimDetails?.surveyorAppointmentStatus !== '') ?
            Yup.string().notRequired().matches(noEscChar(`${getAssesmentLabel()}`).regex, noEscChar(`${getAssesmentLabel()}`).msg) :
            Yup.string().matches(noEscChar(`${getAssesmentLabel()}`).regex, noEscChar(`${getAssesmentLabel()}`).msg)
                .test('mandatory-validation', `${getAssesmentLabel()} is required`, function (value) {
                    if (userRole === 'Insurer') {
                        return value;
                    }
                    return true;
                })
                .test(
                    'is-greater-than-zero',
                    `${getAssesmentLabel()} must be greater than 0`,
                    function (value) {
                        const surveyorAssesmentAmount = value ? parseFloat(value) : 0;
                        if (surveyorAssesmentAmount || surveyorAssesmentAmount == 0) {
                            return (
                                surveyorAssesmentAmount > 0
                            );
                        } else {
                            return true
                        }
                    }).matches(decimalNum(10, 3, `${getAssesmentLabel()}`).regex, decimalNum(10, 3, `${getAssesmentLabel()}`).msg)
                .required(required(`${getAssesmentLabel()}`).msg),
        claimSettlementListSettledAmount: Yup.array().of(
            Yup.object().shape({
                insurerApprovedAmount: Yup.string().matches(noEscChar("Insurer Approved Amount").regex, noEscChar("Insurer Approved Amount").msg).test('insurerapprovedamount-mandatory-validation', 'Insurer Approved Amount is required', function (value) {
                    if (userRole === 'Insurer') {
                        return value;
                    }
                    return true;
                }).test(
                    'is-greater-than-zero',
                    'Insurer Approved Amount must be greater than 0',
                    function (value) {
                        const insurerApprovedAmount = value ? parseFloat(value) : 0;
                        if (insurerApprovedAmount || insurerApprovedAmount == 0) {
                            return (
                                insurerApprovedAmount > 0
                            );
                        } else {
                            return true
                        }
                    }).matches(decimalNum(10, 3, 'Insurer Approved Amount').regex, decimalNum(10, 3, 'Insurer Approved Amount').msg)
                    .required(required('Insurer Approved Amount').msg),
                utrNumber: Yup.string().matches(noEscChar("UTR No.").regex, noEscChar("UTR No.").msg).max(100, 'UTR No. must be less than 100 characters').matches(policyRegexHyphenSlashScore('UTR No.').regex, policyRegexHyphenSlashScore('UTR No.').msg).test('utr-no-validation', 'UTR No. is required', function (value) {
                    if (userRole === 'Insurer') {
                        return value;
                    }
                    return true;
                }),
                utrDate: Yup.date().required(required("UTR Date").msg),
            })
        ),
    });

    const getClaimSettlement = async () => {
        const payload = { claimId: raiseClaimId }
        setIsLoading(true)
        const response = await raiseClaimService.getClaimSettlement(payload)
        if (response?.data?.isSuccess) {
            setClaimSettlementList(response.data.data[0])
        }
        setIsLoading(false)
    }

    const addClaimSettlement = async (values) => {
        // let onAccountReInsAmount = +values?.claimSettlementListOnAccount[0].reInstatementPremium;
        // let settledAmount = +values?.claimSettlementListSettledAmount[0].reInstatementPremium;
        // let isValidation = onAccountReInsAmount || 0 + settledAmount || 0;
        // if (isOnAccountEnabled && isSettlementEnabled) {
        //     isValidation = isValidation + +values?.claimSettlementListOnAccount[0].insurerApprovedAmount + +values?.claimSettlementListSettledAmount[0].insurerApprovedAmount;
        // }
        // else if (isOnAccountEnabled) {
        //     isValidation = isValidation + +values?.claimSettlementListOnAccount[0].insurerApprovedAmount;
        // }
        // else if (isSettlementEnabled) {
        //     isValidation = isValidation + +values?.claimSettlementListSettledAmount[0].insurerApprovedAmount;
        // }
        // let onAccountReInsAmount = +values?.claimSettlementListOnAccount[0].reInstatementPremium;
        //let settledAmount = +values?.claimSettlementListSettledAmount[0].reInstatementPremium;//0
        //let isValidation = settledAmount + +values?.claimSettlementListSettledAmount[0].insurerApprovedAmount;//30000

        // 3000>30000
        // if (checkSettled === "Fully" && claimDetails?.surveyorAppointmentStatus === "Self Surveyor") {
        //     if (+values?.surveyorAssesmentAmount > isValidation) {
        //         toast.error("Total settled amount should not be greater than Estimated Loss Amount")
        //         return
        //     }
        // }

        // if (checkSettled === "Fully" && claimDetails?.surveyorAppointmentStatus !== "Self Surveyor") {
        //     if (+values?.surveyorAssesmentAmount > isValidation) {
        //         toast.error("Total settled amount should not be greater than Surveyor Assesment Amount")
        //         return
        //     }
        // }
        // if (checkSettled === "Partially" && claimDetails?.surveyorAppointmentStatus === "Self Surveyor") {
        //     if (+values?.surveyorAssesmentAmount <= isValidation) {
        //         toast.error("Total partially settled amount should not be equal or greater than Estimated Loss Amount")
        //         return
        //     }
        // }
        // if (checkSettled === "Partially" && claimDetails?.surveyorAppointmentStatus !== "Self Surveyor") {
        //     if (+values?.surveyorAssesmentAmount <= isValidation) {
        //         toast.error("Total partially settled amount should not be equal or greater than Surveyor Assesment Amount")
        //         return
        //     }
        // }

        let payload = {
            claimRaiseId: raiseClaimId,
            settlementType: checkSettled,
        }


        // if (isOnAccountEnabled && isSettlementEnabled) {
        //     payload = {
        //         ...payload,
        //         insurerData: [values?.claimSettlementListOnAccount[0], values?.claimSettlementListSettledAmount[0]]
        //     }
        // } else if (isOnAccountEnabled) {
        //     payload = {
        //         ...payload,
        //         insurerData: values?.claimSettlementListOnAccount,
        //     }
        // } else if (isSettlementEnabled) {
        //     payload = {
        //         ...payload,
        //         insurerData: values?.claimSettlementListSettledAmount,
        //     }
        // }

        // if (isOnAccountEnabled && isSettlementEnabled) {
        //     payload = {
        //         ...payload,
        //         insurerData: [values?.claimSettlementListOnAccount[0], values?.claimSettlementListSettledAmount[0]]
        //     }
        // }
        // if (isOnAccountEnabled) {
        //     payload = {
        //         ...payload,
        //         insurerData: values?.claimSettlementListOnAccount,
        //     }
        // }
        // if (isSettlementEnabled) {
        payload = {
            ...payload,
            insurerData: values?.claimSettlementListSettledAmount,
        }
        // }

        setIsSubmitted(true)
        const response = await raiseClaimService.addClaimSettlement(payload);
        if (response?.data?.isSuccess) {
            await getClaimSettlement();
            await fetchClaimTemplateDetails(raiseClaimId);
            toast.success(response?.data?.message);
        } else {
            toast.error(response?.data?.message);
        }
        setIsSubmitted(false)
    }

    useEffect(() => {
        const fetchList = async () => {
            await getClaimSettlement()
        };
        fetchList();
    }, []);

    return (
        <Modal isOpen={isModalOpen} toggle={handleClose} size="xl">
            <ModalHeader toggle={handleClose}>Claim Settlement</ModalHeader>
            <ModalBody>
                <div>
                    {!isLoading && <Formik
                        initialValues={{
                            surveyorAssesmentAmount: claimSettlementList?.surveyorAssesmentAmount ? claimSettlementList?.surveyorAssesmentAmount : "",
                            onAccountPayment: claimSettlementList?.prevOnAccountPayment || "",
                            settlementAmount: claimSettlementList?.prevSettlementAmount || "",
                            // claimSettlementListOnAccount: [{ id: 0, amountType: "Account Payment", insurerApprovedAmount: "", reInstatementPremium: 0, utrNumber: '', utrDate: null }],
                            claimSettlementListSettledAmount: [{ id: 0, amountType: "Settled Amount", insurerApprovedAmount: "", reInstatementPremium: 0, utrNumber: '', utrDate: null }],
                        }}
                        validationSchema={validationSchema}
                        onSubmit={addClaimSettlement}
                        enableReinitialize
                    >
                        {({ errors, touched, dirty, setFieldValue, values, setFieldTouched }) => {
                            return <Form>
                                <div>

                                    <div className='d-flex' style={{ justifyContent: "space-between" }}>
                                        <div className="form-group fieldArrayBox" style={{ width: "32%" }}>
                                            <label htmlFor="surveyorAssesmentAmount">{`${getAssesmentLabel()}`} {userRole == 'Insurer' ? "*" : ''}</label>
                                            <Field
                                                type="text"
                                                className={`form-control ${touched.surveyorAssesmentAmount && errors.surveyorAssesmentAmount ? 'is-invalid' : ''}`}
                                                id="surveyorAssesmentAmount"
                                                name="surveyorAssesmentAmount"
                                                placeholder="NA"
                                                disabled
                                            />
                                            {errors.surveyorAssesmentAmount && touched.surveyorAssesmentAmount ? (
                                                <p className="errorMsg">{errors.surveyorAssesmentAmount}</p>) : null}
                                        </div>
                                        <div className="form-group  fieldArrayBox" style={{ width: "32%" }}>
                                            <label htmlFor="onAccountPayment">Previous On Account Payment</label>
                                            <Field
                                                type="text"
                                                className='form-control'
                                                id="onAccountPayment"
                                                name="onAccountPayment"
                                                placeholder="NA"
                                                disabled
                                            />
                                            {/* {errors.surveyorAssesmentAmount && touched.surveyorAssesmentAmount ? (
                                                <p className="errorMsg">{errors.surveyorAssesmentAmount}</p>) : null} */}
                                        </div>
                                        <div className="form-group  fieldArrayBox" style={{ width: "32%" }}>
                                            <label htmlFor="settlementAmount">Previous Settlement Amount</label>
                                            <Field
                                                type="text"
                                                className='form-control'
                                                id="settlementAmount"
                                                name="settlementAmount"
                                                placeholder="NA"
                                                disabled
                                            />
                                            {/* {errors.surveyorAssesmentAmount && touched.surveyorAssesmentAmount ? (
                                                <p className="errorMsg">{errors.surveyorAssesmentAmount}</p>) : null} */}
                                        </div>
                                    </div>

                                    <Accordion className='mt-3'>
                                        <AccordionItem>
                                            <AccordionHeader style={{ pointerEvents: "none" }}>Settlement Amount</AccordionHeader>
                                            <AccordionBody>
                                                {/* <input
                                                    type="checkbox"
                                                    disabled={false}
                                                    checked={isSettlementEnabled}
                                                    onChange={() => {
                                                        if (isSettlementEnabled) {
                                                            values.claimSettlementListSettledAmount.forEach((_, index) => {
                                                                setFieldValue(`claimSettlementListSettledAmount.${index}.insurerApprovedAmount`, '');
                                                                setFieldValue(`claimSettlementListSettledAmount.${index}.reInstatementPremium`, '');
                                                                setFieldValue(`claimSettlementListSettledAmount.${index}.utrNumber`, '');
                                                                setFieldValue(`claimSettlementListSettledAmount.${index}.utrDate`, null);
                                                            });
                                                        }
                                                        setSettlementEnabled(!isSettlementEnabled)
                                                    }}
                                                    className="me-2"
                                                /> */}

                                                <FieldArray name="claimSettlementList">
                                                    {() => (
                                                        <div>
                                                            {values?.claimSettlementListSettledAmount?.length > 0 &&
                                                                values?.claimSettlementListSettledAmount?.map((settlement, index) => (
                                                                    <div className="d-flex flex-wrap" style={{ justifyContent: "space-between" }} key={settlement?.id}>
                                                                        <div className="form-group mb-3 fieldArrayBox" style={{ width: "48%" }}>
                                                                            <label htmlFor={`claimSettlementListSettledAmount.${index}.insurerApprovedAmount`}>Amount *</label>
                                                                            <Field
                                                                                type="text"
                                                                                // disabled={!isSettlementEnabled}
                                                                                className={`form-control ${touched.claimSettlementListSettledAmount?.[index]?.insurerApprovedAmount &&
                                                                                    errors.claimSettlementListSettledAmount?.[index]?.insurerApprovedAmount
                                                                                    ? "is-invalid"
                                                                                    : ""
                                                                                    }`}
                                                                                id={`claimSettlementListSettledAmount.${index}.insurerApprovedAmount`}
                                                                                name={`claimSettlementListSettledAmount.${index}.insurerApprovedAmount`}
                                                                                placeholder="Enter Insurer Approved Amount"
                                                                            />
                                                                            {errors.claimSettlementListSettledAmount?.[index]?.insurerApprovedAmount &&
                                                                                touched.claimSettlementListSettledAmount?.[index]?.insurerApprovedAmount && (
                                                                                    <p className="errorMsg">
                                                                                        {errors.claimSettlementListSettledAmount[index].insurerApprovedAmount}
                                                                                    </p>
                                                                                )}
                                                                        </div>
                                                                        <div className="form-group mb-3 fieldArrayBox" style={{ width: "48%" }}>
                                                                            <label htmlFor={`claimSettlementListSettledAmount.${index}.reInstatementPremium`}>
                                                                                Re-Instatement/Adjustment Amount
                                                                            </label>
                                                                            <Field
                                                                                type="text"
                                                                                // disabled={!isSettlementEnabled}
                                                                                className="form-control"
                                                                                id={`claimSettlementListSettledAmount.${index}.reInstatementPremium`}
                                                                                name={`claimSettlementListSettledAmount.${index}.reInstatementPremium`}
                                                                                placeholder="Enter Re-Instatement/Adjustment Amount"
                                                                            />
                                                                        </div>
                                                                        <div className="form-group mb-3 fieldArrayBox" style={{ width: "48%" }}>
                                                                            <label htmlFor={`claimSettlementListSettledAmount.${index}.utrNumber`}>UTR No. *</label>
                                                                            <Field
                                                                                type="text"
                                                                                // disabled={!isSettlementEnabled}
                                                                                className={`form-control ${touched.claimSettlementListSettledAmount?.[index]?.utrNumber &&
                                                                                    errors.claimSettlementListSettledAmount?.[index]?.utrNumber
                                                                                    ? "is-invalid"
                                                                                    : ""
                                                                                    }`}
                                                                                id={`claimSettlementListSettledAmount.${index}.utrNumber`}
                                                                                name={`claimSettlementListSettledAmount.${index}.utrNumber`}
                                                                                placeholder="Enter UTR Number"
                                                                            />
                                                                            {errors.claimSettlementListSettledAmount?.[index]?.utrNumber &&
                                                                                touched.claimSettlementListSettledAmount?.[index]?.utrNumber && (
                                                                                    <p className="errorMsg">{errors.claimSettlementListSettledAmount[index].utrNumber}</p>
                                                                                )}
                                                                        </div>
                                                                        <div className="form-group fieldArrayBox mb-3" style={{ width: "48%" }}>
                                                                            <label htmlFor={`claimSettlementListSettledAmount.${index}.utrDate`}>UTR Date *</label>
                                                                            <DatePicker
                                                                                // disabled={!isSettlementEnabled}
                                                                                selected={values.claimSettlementListSettledAmount[index].utrDate}
                                                                                onChange={(date) =>
                                                                                    setFieldValue(`claimSettlementListSettledAmount.${index}.utrDate`, moment(date).format("YYYY-MM-DD"))
                                                                                }
                                                                                dateFormat="dd/MM/yyyy"
                                                                                autoComplete="off"
                                                                                className={`form-control ${touched.claimSettlementListSettledAmount?.[index]?.utrDate &&
                                                                                    errors.claimSettlementListSettledAmount?.[index]?.utrDate
                                                                                    ? "is-invalid"
                                                                                    : ""
                                                                                    } full-width-datepicker`}
                                                                                name={`claimSettlementListSettledAmount.${index}.utrDate`}
                                                                                onBlur={() => setFieldTouched(`claimSettlementListSettledAmount.${index}.utrDate`, true)}
                                                                                placeholderText="Enter UTR Date"
                                                                                minDate={new Date(parsedclaimIntimationDate)}
                                                                                maxDate={new Date()}
                                                                            />
                                                                            {touched.claimSettlementListSettledAmount?.[index]?.utrDate &&
                                                                                errors.claimSettlementListSettledAmount?.[index]?.utrDate && (
                                                                                    <p className="errorMsg">{errors.claimSettlementListSettledAmount[index].utrDate}</p>
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    )}
                                                </FieldArray>
                                                {/* <div style={{ display: "flex", justifyContent: "end" }} className="mt-3">
                                                    <Button color="primary" type="submit" className="ITC_Blue_color" disabled={!dirty || isSubmitted}>
                                                        Submit
                                                    </Button>
                                                </div> */}
                                            </AccordionBody>
                                        </AccordionItem>
                                    </Accordion>
                                </div>
                                <div style={{ display: "flex", justifyContent: "end" }} className='mt-3'>
                                    <Button color="primary" type="submit" className="ITC_Blue_color" disabled={!dirty || isSubmitted}>
                                        Submit
                                    </Button>
                                </div>
                            </Form>
                        }}
                    </Formik>}
                </div>
            </ModalBody>
        </Modal >
    );
};

export default MultipleAmountAddCommonModal